/**
 * Dark by default, light on request, remembered per browser. Storage can be
 * missing or throw (private windows, blocked site data), so every access is
 * guarded and the panel simply falls back to dark.
 */
export type Theme = 'dark' | 'light';

const KEY = 'fleet.theme';

export function storedTheme(): Theme {
  try {
    return localStorage.getItem(KEY) === 'light' ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
}

export function applyTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    // Not remembered this time; the page still switches.
  }
}

export function otherTheme(theme: Theme): Theme {
  return theme === 'dark' ? 'light' : 'dark';
}
